/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingpublishfacebook2Inputs */

const en_crosspostingpublishfacebook2 = /** @type {(inputs: Crosspostingpublishfacebook2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish to Facebook`)
};

const de_crosspostingpublishfacebook2 = /** @type {(inputs: Crosspostingpublishfacebook2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Facebook veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish to Facebook" |
*
* @param {Crosspostingpublishfacebook2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingpublishfacebook2 = /** @type {((inputs?: Crosspostingpublishfacebook2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingpublishfacebook2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingpublishfacebook2(inputs)
	return de_crosspostingpublishfacebook2(inputs)
});
export { crosspostingpublishfacebook2 as "crosspostingPublishFacebook" }